/* eslint-disable arrow-body-style */
export const findProductInCurrentCategory = state => (productId) => {
  if (state.currentCategory
    && state.currentCategory.products
    && state.currentCategory.products.length > 0) {
    return state.currentCategory.products.find(product => product.id === productId);
  }
  return null;
};

export const findProduct = state => (productId) => {
  let product = null;
  state.categories.forEach((category) => {
    if (category.products && category.products.length > 0) {
      category.products.forEach((p) => {
        if (p.id === productId) {
          product = p;
        }
      });
    }
  });

  return product;
};

export const findCategory = state => (categoryId) => {
  return state.categories.find(category => category.id === categoryId);
};

export const findCategories = state => (categories) => {
  state.categories.filter(category => this.indexOf(category) < 0, categories);
};

export const findImportableCategory = state => (categoryId) => {
  return state.rootCategory.children.find(category => category.id === categoryId);
};
